import React from "react";
import { motion } from "framer-motion";
import { pageTransition } from "../motion/presets";
import { ShimmerBox } from "./SkeletonComponents";
import AnimatedLoader from "../../motionKit/AnimatedLoader";

// Fallback shown while a lazy-loaded route chunk is downloading. The
// sidebar/header persist outside Suspense, so this only fills the content
// region: the Remotion-powered FK loader (plane orbiting the tile) carries the
// brand, with two skeleton cards underneath to read as "content loading".
// AnimatedLoader handles reduced-motion and lazy-loads the player itself, so
// this stays instant to first paint.
function RouteFallback() {
  return (
    <motion.div
      {...pageTransition}
      className="w-full space-y-4 p-6 lg:p-8"
      aria-busy="true"
      aria-label="Loading"
    >
      <div className="flex justify-center py-4">
        <AnimatedLoader variant="route" size={140} label="Loading workspace" />
      </div>
      {[0, 1].map((i) => (
        <div
          key={i}
          className="rounded-xl border border-slate-200/70 bg-white/60 p-5 shadow-sm dark:border-[oklch(0.3_0.02_264/0.6)] dark:bg-[oklch(0.225_0.026_264/0.4)]"
        >
          <ShimmerBox width="40%" height="18px" className="mb-4" />
          <ShimmerBox width="100%" height="14px" className="mb-2.5" />
          <ShimmerBox width="85%" height="14px" className="mb-2.5" />
          <ShimmerBox width="60%" height="14px" />
        </div>
      ))}
    </motion.div>
  );
}

export default RouteFallback;
